import { Box } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import React, { useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { MISSING_FIELD } from '../../constants/missingField';
import { useAppContext } from '../../context/appContext';
import {
  emailSchema,
  mobilePhoneSchema,
  phoneCountrySchema,
  pincodeSchema,
} from '../../utils/yupSchema';
import EmailForm from './forms/EmailForm';
import MobileForm from './forms/MobileForm';

const CompleteInfoSection = () => {
  const { smsVerificationEnabled, missingFields } = useAppContext();
  const [missingField] = missingFields;

  const schema = useMemo(() => {
    switch (missingField) {
      case MISSING_FIELD.MOBILE:
        return yup.object().shape({
          phone_country: phoneCountrySchema,
          mobile_phone: mobilePhoneSchema,
          ...(smsVerificationEnabled ? { pincode: pincodeSchema } : {}),
        });
      case MISSING_FIELD.EMAIL:
        return yup.object().shape({ email: emailSchema });
      // no default
    }
  }, [missingField, smsVerificationEnabled]);

  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(schema),
  });

  return (
    <Box>
      <FormProvider {...methods}>
        {missingField === MISSING_FIELD.MOBILE && <MobileForm />}
        {missingField === MISSING_FIELD.EMAIL && <EmailForm />}
      </FormProvider>
    </Box>
  );
};

export default CompleteInfoSection;
